<template><img class="logo" :style="{height: height + 'px'}" src="@/assets/images/logo.svg" alt=""></template><script> export default {name: 'o-logo', props: {height: {default: '48'}}};</script>
